import { features } from '@/mocks/features';

export default function FeatureGrid() {
  return (
    <section className="relative py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border-2 border-primary-500 text-primary-600 text-xs font-medium mb-4 whitespace-nowrap">
            Por que Escolher
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-900 leading-tight mb-3">
            Segurança / e Economia
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto leading-relaxed">
            O <strong>HoobuySpreadsheet</strong> foi criado para resolver os maiores problemas de quem compra online.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-5 md:p-6 rounded-2xl bg-background-100 cursor-pointer transition-all duration-300 hover:bg-accent-500"
            >
              {/* Icon */}
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-foreground-900 flex items-center justify-center mb-4 transition-colors duration-300 group-hover:bg-background-50">
                <i className={`${feature.icon} text-xl md:text-2xl text-background-50 transition-colors duration-300 group-hover:text-foreground-900 w-6 h-6 md:w-7 md:h-7 flex items-center justify-center`}></i>
              </div>

              {/* Tag */}
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-3 whitespace-nowrap transition-colors duration-300 group-hover:bg-background-50/30 group-hover:text-background-50">
                {feature.tag}
              </span>

              {/* Title */}
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2 transition-colors duration-300 group-hover:text-background-50">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-foreground-500 text-sm leading-relaxed transition-colors duration-300 group-hover:text-background-100">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}